module.exports = __webpack_public_path__ + "img/hrdesk-logo-dark-beta.2860e798.png";